var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.585H10.5556M22 8.58496V10.1405M33.4444 22.585H35M12.0444 12.6294L13.1333 13.7183M31.9556 12.6294L30.8667 13.7183",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 30.4053C24.8 29.4737 24.7554 29.3265 24.9986 28.5912C25.2418 27.8558 25.6534 27.6493 26.2 27.1039C27.3753 26.2155 28.2435 24.9769 28.6816 23.5636C29.1197 22.1503 29.1054 20.6339 28.6408 19.2292C28.1762 17.8245 27.2848 16.6027 26.093 15.7369C24.9011 14.8712 23.4692 14.4053 22 14.4053C20.5308 14.4053 19.0989 14.8712 17.907 15.7369C16.7152 16.6027 15.8238 17.8245 15.3592 19.2292C14.8946 20.6339 14.8803 22.1503 15.3184 23.5636C15.7565 24.9769 16.6247 26.2155 17.8 27.1039C18.3466 27.6493 18.7582 27.8558 19.0014 28.5912C19.2446 29.3265 19.2 29.4737 19.2 30.4053",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 35.415H24.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.421 32.9463H25.5766",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSupport);
export default __webpack_public_path__ + "static/media/btn_support.eb39e324dc76009f444ca261558f5f62.svg";
export { ForwardRef as ReactComponent };